/** GitHub Release .dmg URL for the latest macOS IDE build (tester v1). */
export function getIdeDownloadUrl(): string | undefined {
  const raw = import.meta.env.VITE_IDE_DOWNLOAD_URL as string | undefined;
  const trimmed = raw?.trim();
  return trimmed ? trimmed : undefined;
}

/** GitHub Release .exe URL for the latest Windows IDE build (tester v1, Phase 2). */
export function getIdeDownloadUrlWin(): string | undefined {
  const raw = import.meta.env.VITE_IDE_DOWNLOAD_URL_WIN as string | undefined;
  const trimmed = raw?.trim();
  return trimmed ? trimmed : undefined;
}

/** Lightweight UA sniff — good enough for adjacent platform copy, not for blocking download. */
export function isMacOsUserAgent(userAgent: string): boolean {
  return /Mac OS X|Macintosh/i.test(userAgent);
}

export function isWindowsUserAgent(userAgent: string): boolean {
  return /Windows NT|Win64|Win32/i.test(userAgent);
}

/**
 * One-shot platform resolver used by LandingHero (CTA label flip) and
 * IdeDownloadPanel (default tab selection). Returns `'unknown'` for Linux,
 * iPadOS, mobile, and empty UAs — the consumer decides the fallback.
 */
export function detectPlatform(userAgent: string): 'mac' | 'win' | 'unknown' {
  if (isMacOsUserAgent(userAgent)) return 'mac';
  if (isWindowsUserAgent(userAgent)) return 'win';
  return 'unknown';
}

export function shouldShowNonMacPlatformNote(userAgent: string): boolean {
  return !isMacOsUserAgent(userAgent);
}

/** Terminal commands to clear quarantine and launch the IDE after install. */
export const MACOS_IDE_LAUNCH_COMMANDS = `xattr -cr "/Applications/Penrose IDE.app"
open "/Applications/Penrose IDE.app"`;

const DEFAULT_GITHUB_RELEASES = 'https://github.com/MalakHimse1f/penrose-ide/releases';

/** GitHub Releases page for the IDE — derived from the configured download URL when possible. */
export function getIdeGithubReleasesUrl(platform: 'mac' | 'win' = 'mac'): string {
  const downloadUrl =
    platform === 'win' ? getIdeDownloadUrlWin() : getIdeDownloadUrl();
  if (downloadUrl) {
    const match = downloadUrl.match(/^(https:\/\/github\.com\/[^/]+\/[^/]+)\//);
    if (match) return `${match[1]}/releases`;
  }
  return DEFAULT_GITHUB_RELEASES;
}
